import React, { useState } from 'react'
import { Container } from 'react-bootstrap'
import { Link, useParams } from 'react-router-dom';
import CelltrionCare from "../popup/celltrionCare";
import entryImage from '../../assets/img/yuflyma-entry.jpg';

export const AdalimumabAATYEntry = () => {
  const [modalShow, setModalShow] = useState(false);
      const { category } = useParams();
      const productName = category;

    return (
        <><section className={`entry ${productName}-entry`} style={{ backgroundImage: `url(${entryImage})` }}>
            <Container style={{ marginTop: "70px" }}>
                <div className='entry-text'>
                    <Link to="/inquiry-form/adalimumab" className='theme-btn'>Enroll in Co-pay Program</Link>
                    <p className='text-1'>Commercially insured patients taking Adalimumab-aaty may be able to receive assistance through the Celltrion CARES<sup className='reg'>&reg;</sup> Co-pay Assistance Program.</p>
                    <h5>If eligible, patients may pay as little as $0
                        for Adalimumab-aaty.
                    </h5>
                    <p className='text-2'>Celltrion CARES<sup className='reg'>&reg;</sup> provides assistance to help with patient out-of-pocket costs
                        for Adalimumab-aaty.</p>
                    <p className='text-3'>In order to be eligible for Celltrion CARES<sup className='reg'>&reg;</sup> Co-pay
                        Assistance, patients:
                    </p>
                    <ul>
                        <li>
                            Must have commercial or private insurance
                        </li>
                        <li>
                            Must not have Medicare, Medicaid,
                            or other government insurance

                        </li>
                        <li style={{ lineHeight: 1.5 }}>Must meet certain guidelines set
                            forth in the <a
                                href="#"
                                onClick={() => setModalShow(true)}
                                style={{
                                    color: "#000000",
                                    textDecoration: "underline",
                                }}
                            >Terms and Conditions</a>&nbsp;
                            for the Celltrion CARES<sup>&reg;</sup> Co-pay Assistance Program
                        </li>
                    </ul>
                    <p className='text-3'>
                        If you have any questions about the
                        Celltrion CARES<sup>&reg;</sup> Co-pay Assistance
                        Program for Adalimumab-aaty or
                        pharmacy assistance, please call
                        1.877.81CONNC (1.877.812.6662)<br></br>
                        Monday-Friday, 8 AM-8 PM ET.
                    </p>
                </div>
            </Container>
        </section><CelltrionCare
                show={modalShow}
                onHide={() => setModalShow(false)}
                isVegzelma={false}
                isZymfentra={false}
                isYuflyma={false}
                isAdalimumab={true}
                isSteqeyma={false} /></>        
    )
}
